import { createFileRoute } from "@tanstack/react-router"
import { WorkflowsCanvas } from "modules/workflows/components/Builder"

export const Route = createFileRoute("/_base/_auth/settings/workflows/")({
  component: GlobalWorkflows,
})

function GlobalWorkflows() {
  return (
    <div className="flex flex-1 flex-col min-h-[600px] rounded-lg border overflow-hidden">
      <WorkflowsCanvas />
    </div>
  )
}
